import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Pagination, Confirm, Form } from "semantic-ui-react";
import "./WithdrawList.scss";
import CustomHeader from "../../../components/Headers/CustomHeader";
import { reduxForm } from "redux-form";
import { withRouter } from "react-router";
import {
  getAllWithdrawList,
  approveDisapproveRequest,
  withdrawComment,
} from "../../../Redux/actons/withdraw.action";
import { listDateFormat } from "../../../utils/utils";

import { toast } from "../../../components/Toast/Toast";
import Security from "../../SubAdminManagement/AddNewSubAdmin/Security";
import {
  BTC_TXN_BTC,
  ETH_TXN_ETH,
  BTC_ADDRESS_BTC,
  ETH_ADDRESS_ETH,
  BSC_TXN_BSC,
  MATIC_TXN_MATIC,
  BSC_ADDRESS_BSC,
  MATIC_ADDRESS_MATIC,
} from "../../../constants/index";

export class PendingWithdrawList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchKey: "",
      perPage: "10",
      page: "1",
      order: "asc",
      sortBy: "",
      openConfirm: false,
      action: "",
      transId: "",
      showDetails: false,
      tx_details: {},
      showComment: false,
      comment: "",
      user_id: "",
      coin: "",
      type: "pending",
    };
  }
  toggleModal = () => {
    this.setState({ showDetails: !this.state.showDetails });
  };
  openCommentModal = (data) => {
    this.setState({
      showComment: !this.state.showComment,
      user_id: data.user_id,
    });
  };
  toggleCommentModal = () => {
    this.setState({ showComment: !this.state.showComment });
  };
  componentDidMount = () => {
    this.getWithdrawList();
  };
  redirectToHashSite = (coin, hash) => {
    if (coin === "btc") {
      window.open(`${BTC_TXN_BTC}/${hash}`, "_blank");
    }
    if (coin === "eth" || coin === "ida" || coin === "orbs") {
      window.open(`${ETH_TXN_ETH}/${hash}`, "_blank");
    }
    if (coin == "bnb" || coin == "busd" || coin == "rena") {
      window.open(`${BSC_TXN_BSC}/${hash}`, "_blank");
    }
    if (coin == "matic") {
      window.open(`${MATIC_TXN_MATIC}/${hash}`, "_blank");
    }
  };

  redirectUrl = (coin, address) => {
    if (coin === "btc") {
      window.open(`${BTC_ADDRESS_BTC}/${address}`, "_blank");
    }
    if (coin === "eth" || coin === "ida" || coin === "orbs") {
      window.open(`${ETH_ADDRESS_ETH}/${address}`, "_blank");
    }
    if (coin == "bnb" || coin == "busd" || coin == "rena") {
      window.open(`${BSC_ADDRESS_BSC}/${address}`, "_blank");
    }
    if (coin == "matic") {
      window.open(`${MATIC_ADDRESS_MATIC}/${address}`, "_blank");
    }
  };
  showDetails = (tx) => {
    this.setState({ tx_details: tx }, () => {
      this.toggleModal();
    });
  };
  getWithdrawList = () => {
    let data = {
      searchKey: this.state.searchKey,
      perPage: this.state.perPage,
      page: this.state.page,
      order: this.state.order,

      //   type: this.state.type,
    };
    var fData = {
      coin_type: "",
      from_date: "",
      to_date: "",
      status: this.state.type,
    };
    this.props.getAllWithdrawList(data, fData);
  };

  sortBy = (e, data) => {
    this.setState({ order: data.value }, () => {
      this.getWithdrawList();
    });
  };
  filterBy = (e, data) => {
    if (data.value !== "none") {
      this.setState({ type: data.value }, () => {
        this.getWithdrawList();
      });
    } else {
      this.setState({ type: "" }, () => {
        this.getWithdrawList();
      });
    }
  };
  //page change
  changeApprovedPage = (e, data) => {
    this.setState({ page: data.activePage }, () => {
      this.getWithdrawList();
    });
  };
  //search
  onSearchWithdraw = (abc) => {
    this.setState({ searchKey: abc, page: 1 }, () => {
      this.getWithdrawList();
    });
  };
  openConfirmApproveModal = (id, transId, coin_symbol) => {
    this.setState({
      openConfirm: true,
      action: id,
      transId: transId,
      coin: coin_symbol,
    });
  };
  close = () => {
    this.setState({ openConfirm: false });
  };
  onConfirmation = () => {
    let data = {
      id: this.state.transId,
      action: this.state.action,
      coin: this.state.coin,
    };
    this.props.approveDisapproveRequest(data);
    this.setState({ openConfirm: false });
    this.props.history.push("/index");
  };
  setMessage = (e) => {
    this.setState({ comment: e.target.value });
  };
  sendMesage = () => {
    if (this.state.comment !== "") {
      this.setState({ showComment: false });
      let data = {
        comment: this.state.comment,
        user_id: this.state.user_id,
      };
      this.props.withdrawComment(data);
    } else {
      toast.error("Please enter comment");
    }
  };

  render() {
    return (
      <div>
        <Security />
        {/* approve disaprove confirm */}
        <div>
          <Confirm
            content={`Are you sure to ${
              this.state.action == 1 ? "Approve" : "Disapprove"
            }`}
            size="small"
            className="confirm-model"
            open={this.state.openConfirm}
            onCancel={this.close}
            onConfirm={this.onConfirmation}
          />
        </div>
        <CustomHeader />
        {!this.props.openSecurityModal && (
          <div>
            <Container className="contentBlock" fluid>
              {/* Table */}
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <div style={{ width: "100%" }}>
                        <h3 className="mb-2">Pending Withdraw List</h3>
                      </div>
                      <div className="selectSearchOption">
                        <Input
                          placeholder="Search"
                          onChange={(e) =>
                            this.onSearchWithdraw(`${e.target.value}`)
                          }
                        ></Input>
                      </div>
                    </CardHeader>
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-dark">
                        <tr>
                          <th scope="col">ID(Email)</th>
                          <th scope="col">Asset</th>

                          <th scope="col">Amount</th>
                          <th scope="col">To</th>

                          <th scope="col">Status</th>
                          <th scope="col">TXID</th>

                          <th scope="col">Tx Time</th>

                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.withdrawList.map((usersList, index) => (
                          <tr className="table-tr" key={index}>
                            <td>{usersList.email}</td>
                            <td>{usersList.coin_symbol.toUpperCase()}</td>

                            <td>{usersList.amount}</td>

                            <td
                              title={usersList.to_adrs}
                              onClick={() =>
                                this.redirectUrl(
                                  usersList.coin_symbol,
                                  usersList.to_adrs
                                )
                              }
                            >
                              {usersList.to_adrs
                                ? usersList.to_adrs.slice(0, 12) + "..."
                                : "NONE"}
                            </td>

                            <td>{usersList.status.toUpperCase()}</td>

                            <td
                              title={usersList.tx_id}
                              onClick={() =>
                                this.redirectToHashSite(
                                  usersList.coin_symbol,
                                  usersList.tx_id
                                )
                              }
                            >
                              {usersList.tx_id
                                ? usersList.tx_id.slice(0, 12) + "..."
                                : "NONE"}
                            </td>

                            <td>{listDateFormat(usersList.updated_at)}</td>

                            <td>
                              {usersList.status !== "complete" &&
                                usersList.status !== "rejected" && (
                                  <span className="mb-0 text-sm">
                                    <Button
                                      color="success"
                                      onClick={() =>
                                        this.openConfirmApproveModal(
                                          1,
                                          usersList.id,
                                          usersList.coin_symbol
                                        )
                                      }
                                    >
                                      Approve
                                    </Button>
                                  </span>
                                )}
                              {usersList.status !== "complete" &&
                                usersList.status !== "rejected" && (
                                  <span
                                    className="mb-0 text-sm"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    <Button
                                      color="warning"
                                      onClick={() =>
                                        this.openConfirmApproveModal(
                                          2,
                                          usersList.id,
                                          usersList.coin_symbol
                                        )
                                      }
                                    >
                                      Reject
                                    </Button>
                                  </span>
                                )}

                              <span
                                className="mb-0 text-sm"
                                style={{ marginLeft: "10px" }}
                              >
                                <Button
                                  color="success"
                                  onClick={() => this.showDetails(usersList)}
                                >
                                  Details
                                </Button>
                              </span>
                              <span
                                className="mb-0 text-sm"
                                style={{ marginLeft: "10px" }}
                              >
                                <Button
                                  color="success"
                                  onClick={() =>
                                    this.openCommentModal(usersList)
                                  }
                                >
                                  Add Comment
                                </Button>
                              </span>
                            </td>
                          </tr>
                        ))}
                        {this.props.withdrawList.length == 0 && (
                          <td>No record found</td>
                        )}
                      </tbody>
                    </Table>
                    <CardFooter className="py-4">
                      <nav aria-label="...">
                        {this.props.totalRecords > 0 && (
                          <Pagination
                            onPageChange={(e, data) =>
                              this.changeApprovedPage(e, data)
                            }
                            boundaryRange={1}
                            defaultActivePage={1}
                            ellipsisItem={true}
                            firstItem={true}
                            lastItem={true}
                            siblingRange={1}
                            totalPages={Math.ceil(
                              this.props.totalRecords / this.state.perPage
                            )}
                          />
                        )}
                      </nav>
                    </CardFooter>
                  </Card>
                </div>
              </Row>
            </Container>
          </div>
        )}
        {/* detail modal */}
        <Modal
          isOpen={this.state.showDetails}
          toggle={this.toggleModal}
          className={[this.props.className, "modalCustom"]}
        >
          <ModalHeader toggle={this.toggleModal}>
            <h1>
              <span>Transaction Informations</span>
            </h1>
          </ModalHeader>
          <ModalBody>
            <div className="userNameList">
              <div className="itemStyle">
                <label>Sent From:</label>
                <span>{this.state.tx_details.from_adrs}</span>
              </div>
              <div className="itemStyle">
                <label>Sent To:</label>
                <span>{this.state.tx_details.to_adrs}</span>
              </div>
              <div className="itemStyle">
                <label>Transaction fee:</label>
                <span>{this.state.tx_details.trnx_fee_eth}</span>
              </div>
            </div>
          </ModalBody>
        </Modal>

        {/* add comment modal  */}
        <Modal isOpen={this.state.showComment} toggle={this.toggleCommentModal}>
          <ModalHeader toggle={this.toggleCommentModal}>
            Send Comment
          </ModalHeader>
          <ModalBody>
            <Form>
              <Form.TextArea
                label=" Comment"
                placeholder="Enter Comment..."
                onChange={(e) => this.setMessage(e)}
              />
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="error"
              onClick={() => this.setState({ showComment: false })}
            >
              Cancel
            </Button>
            <Button color="success" onClick={() => this.sendMesage()}>
              Send
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    withdrawList: state.withdraw.withdrawList,
    totalRecords: state.withdraw.totalRecords,
    openSecurityModal: state.subAdmin.openSecurityModal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllWithdrawList: (data, fdata) =>
      dispatch(getAllWithdrawList(data, fdata)),
    approveDisapproveRequest: (data) =>
      dispatch(approveDisapproveRequest(data)),
    withdrawComment: (data) => dispatch(withdrawComment(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(reduxForm({ form: "ApprovedKyc" })(PendingWithdrawList))
);
